import ApiClientError from "./ApiClientError";

class BadRequestError extends ApiClientError {
  static create: $TSFixMe;

  constructor(request: $TSFixMe, response: $TSFixMe, cause: $TSFixMe) {
    super(
      "BadRequestError",
      400,
      "The data given in the request failed validation.",
      request,
      response,
      cause,
    );
  }
}

BadRequestError.create = (errors: $TSFixMe) =>
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  new BadRequestError(null, { data: { errors } });

export default BadRequestError;
